<template>
  <div id="app">
    <div class="header">{{ detailData.title }}</div>
    <p class="headerTran">
      {{ detailData.synopsis }}
    </p>
    <div
      ref="imageContainer"
      v-html="detailData.contents"
      class="parent-box"
    ></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "FAQContent",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      queryParams: "",
      detailData: {},
      env: process.env.VUE_APP_BASE_API,
    };
  },
  watch: {
    $route(route) {
      console.log("route---FAQContent", route);
    },
  },
  async mounted() {
    this.queryParams = await this.getQueryParams();
    const url = `${this.env}/v2/open/faq/detail/${this.queryParams.id}?lang=${
      this.queryParams?.lang || "en"
    }`;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-version": this.queryParams["version"] ?? 0,
          "x-current-platform": this.queryParams["platform"] ?? "all",
          "x-app-channel": this.queryParams["channel"] ?? "googleplay",
          "x-current-package": this.queryParams["package"] ?? "",
        },
      })
      .then((res) => {
        if (res.data.data) {
          this.detailData = res.data.data;
        }
      });
  },
  methods: {
    goBack() {
      this.$emit("goBack", false);
    },
    getQueryParams() {
      const params = {};
      const queryString = window.location.search.substring(1);
      const pairs = queryString.split("&");
      for (let pair of pairs) {
        const [key, value] = pair.split("=");
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
      return params;
    },
  },
};
</script>

<style scoped>
#app {
  height: auto;
  text-align: left;
}
.header {
  font-family: PingFang SC, serif;
  font-weight: 500;
  font-size: 24px;
  font-variation-settings: "opsz" 8;
  color: #0e273b;
}
.headerTran {
  font-family: PingFang SC, serif;
  font-weight: 500;
  font-size: 14px;
  font-variation-settings: "opsz" 8;
  color: #767676;
  padding: 16px 0px;
}

.parent-box {
  width: 100%;
  height: 200px;
}
.parent-box >>> img {
  width: 100%;
  height: auto; /* 保持图片宽高比 */
}
.parent-box >>> video {
  width: 100%;
  height: auto;
}
</style>
